import { createSlice } from "@reduxjs/toolkit";
// this code for slice value for   Tabvalues
export const Tabvalues = createSlice({
  name: "Tabvalues",
  initialState: {
    api_completed: false,
    isLoading: false,
    isSuccess: false,
    switch: false,
    data: {},
  },
  reducers: {
    Tabvalues_datagrid: (state, a) => {
      state.data = a.payload;
      state.switch = true
    },
    success_api_call_Tabvalues_datagrid: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.api_completed = true;
    },
    failure_api_call_Tabvalues_datagrid: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.isSuccess = false;
      state.api_completed = true;
    },
    Tabvalues_datagrid_is_success: (state, action) => {
      state.isSuccess = false;
    },
    create_Tabvalues_datagrid_complete_api: (state, action) => {
      state.api_completed = false;
    },
    false_switchTabvalues:(state)=>{
        state.switch = false
    }
  },
});
export default Tabvalues.reducer;
export const {
  Tabvalues_datagrid,
  success_api_call_Tabvalues_datagrid,
  failure_api_call_Tabvalues_datagrid,
  create_Tabvalues_datagrid_complete_api,
  Tabvalues_datagrid_is_success,false_switchTabvalues
} = Tabvalues.actions;
